import React from 'react';
import { MDBFooter, MDBContainer, MDBRow, MDBCol } from 'mdb-react-ui-kit';
import { FaAngleDoubleRight } from "react-icons/fa";
import { Link } from 'react-router-dom';
import './footer.css';

export default function Footer() {
  return (
    <MDBFooter className='text-center text-lg-start text-muted' style={{ background: "#080838" }}>
      <section>
        <MDBContainer className='text-center text-md-start mt-5'>
          <MDBRow className='mt-3'>

            {/* Company Info */}
            <MDBCol md="3" lg="4" xl="3" className='mx-auto mb-4'>
              <h5 className='text-uppercase fw-bold mb-4 text-white-footer1' style={{ fontSize:"18px", marginTop:"23px" }}>
                TRIPLETTE IT CONSULTANCY
              </h5>
              <p className="text-white-footer1" style={{ textIndent: "10px", textAlign: "justify" }}>
                We work closely with Level 1 to Level 5 companies, offering our candidates access to a wide spectrum of job roles — from entry-level positions to experienced profiles.
              </p>
            </MDBCol>

            {/* Our Services */}
            <MDBCol md="2" lg="2" xl="2" className='mx-auto mb-4'>
              <h5 className='text-uppercase fw-bold mb-4 text-white-footer1' style={{ fontSize:"18px", marginTop:"23px" }}>Our Services</h5>
              <div className="footer-links-link">
                <p><FaAngleDoubleRight className="icon-style" /> &nbsp;
                  <Link to="/products" className='text-reset'>Job Placement</Link>
                </p>
                <p><FaAngleDoubleRight className="icon-style" /> &nbsp;
                  <Link to="/products" className='text-reset'>Resume Building</Link>
                </p>
                <p><FaAngleDoubleRight className="icon-style" /> &nbsp;
                  <Link to="/products" className='text-reset'>Interview Prep</Link>
                </p>
                <p><FaAngleDoubleRight className="icon-style" /> &nbsp;
                  <Link to="/products" className='text-reset'>Career Counsel</Link>
                </p>
                <p><FaAngleDoubleRight className="icon-style" /> &nbsp;
                  <Link to="/products" className='text-reset'>Skill Program</Link>
                </p>
                <p><FaAngleDoubleRight className="icon-style" /> &nbsp;
                  <Link to="/products" className='text-reset'>Corporate TieUps</Link>
                </p>
              </div>
            </MDBCol>

            {/* Navigation Links */}
            <MDBCol md="3" lg="2" xl="2" className='mx-auto mb-4'>
              <h5 className='text-uppercase fw-bold mb-4 text-white-footer1' style={{ fontSize:"18px", marginTop:"23px" }}>Our Links</h5>
              <div className="footer-links-link">
                <p><FaAngleDoubleRight className="icon-style" /> &nbsp;
                  <Link to="/" className='text-reset'>Home</Link>
                </p>
                <p><FaAngleDoubleRight className="icon-style" /> &nbsp;
                  <Link to="/aboutmain" className='text-reset'>About Us</Link>
                </p>
                <p><FaAngleDoubleRight className="icon-style" /> &nbsp;
                  <Link to="/products" className='text-reset'>Our Services</Link>
                </p>
                <p><FaAngleDoubleRight className="icon-style" /> &nbsp;
                  <Link to="/aboutmain" className='text-reset'>Why Choose us</Link>
                </p>
                <p><FaAngleDoubleRight className="icon-style" /> &nbsp;
                  <Link to="/carrer" className='text-reset'>Career</Link>
                </p>
                <p><FaAngleDoubleRight className="icon-style" /> &nbsp;
                  <Link to="/contact" className='text-reset'>Contact us</Link>
                </p>
              </div>
            </MDBCol>

            {/* Contact */}
            <MDBCol md="3" lg="3" xl="3" className='mx-auto mb-4'>
              <h5 className='text-uppercase fw-bold mb-4 text-white-footer1' style={{ fontSize:"18px", marginTop:"23px" }}>Contact</h5>
              <p className="text-white-footer1">
                No:21, Vinayaga Nagar, Okkiyam Thoraipakkam, Chennai-97
              </p>
              <p className="text-white-footer1">info@triplette.in</p>
              <p className="text-white-footer1">+91 8072712418</p>
            </MDBCol>

          </MDBRow>
        </MDBContainer>
      </section>

      {/* Footer Copyright */}
      <div className='text-center p-2 text-white-footer1' style={{ backgroundColor: 'rgba(0, 0, 0, 0.05)', borderTop:"1px solid white" }}>
        © 2025 Copyright:
        <a className='text-reset fw-bold' href='https://triplette.in/' target='_blank' rel='noreferrer'>
          &nbsp;triplette
        </a>
      </div>
    </MDBFooter>
  );
}
